import PropTypes from "prop-types";
import UiIcon from "./UiIcon";
import "./ui.css";

// Search, Filters button and any extra controls (e.g. Columns) above a table.
export default function TableToolbar({ search, onOpenFilters, filterCount, filtersOpen, extra, meta }) {
  return (
    <div className="simcc-toolbar">
      {search}
      {onOpenFilters && (
        <button
          type="button"
          className="simcc-tool-button"
          aria-expanded={filtersOpen}
          onClick={onOpenFilters}
        >
          <UiIcon name="filter" size={14} />
          Filters
          {filterCount > 0 && <span className="simcc-tool-button__count">{filterCount}</span>}
        </button>
      )}
      {extra}
      {meta && <div className="simcc-toolbar__meta">{meta}</div>}
    </div>
  );
}

TableToolbar.propTypes = {
  search: PropTypes.node,
  onOpenFilters: PropTypes.func,
  filterCount: PropTypes.number,
  filtersOpen: PropTypes.bool,
  extra: PropTypes.node,
  meta: PropTypes.node,
};

TableToolbar.defaultProps = {
  search: undefined,
  onOpenFilters: undefined,
  filterCount: 0,
  filtersOpen: false,
  extra: undefined,
  meta: undefined,
};
